import Mock from 'mockjs'

export default ()=>{
  Mock.mock(/\.do/,{
    'data|0-10':[
      {
        'id|+1':1,
        'name':'@ctitle(6,10)',
        'address':'@csentence(6,22)',
        'distance':'@float(0,100)'
      }
    ]
  })
}
